/*******************************************************************************
 * Copyright (c) 2024. dnote.ai
 *
 * @project DNOTE.AI-Frontend
 * @author dnote.ai
 * @copyright Dnote.ai All rights reserved
 ******************************************************************************/

export const BOOLEANS = [
	{
		label	: "No",
		value	: false,
	},
	{
		label	: "Yes",
		value	: true,
	}
];